import { useSyncExternalStore, useCallback, useMemo } from "react";

const KEY = "rento_favorites";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

const listeners = new Set();
function emit() {
  listeners.forEach((l) => l());
}

function subscribe(cb) {
  listeners.add(cb);
  window.addEventListener("storage", cb);
  return () => {
    listeners.delete(cb);
    window.removeEventListener("storage", cb);
  };
}

export function useFavorites() {
  const json = useSyncExternalStore(
    subscribe,
    () => localStorage.getItem(KEY) || "[]",
    () => "[]"
  );
  const favorites = useMemo(() => JSON.parse(json), [json]);

  const toggle = useCallback((id) => {
    const current = read();
    const next = current.includes(id)
      ? current.filter((x) => x !== id)
      : [...current, id];
    localStorage.setItem(KEY, JSON.stringify(next));
    emit();
  }, []);

  const isFavorite = useCallback((id) => read().includes(id), []);

  return { favorites, toggle, isFavorite };
}
